export default __webpack_public_path__ + "static/media/regulatory--bicycles-only--g3.bcfb72cc.png";